Object.defineProperty(exports, '__esModule', {
  value: true,
});

/**
 * Simple compare function to be passed to Array.sort for ensuring consistent order of definitions in queries.
 * Ensures client and server will generate the same query hash.
 * 
 * @type {(a: {kind: string, name?: {value: string} | undefined}, b: {kind: string, name?: {value: string} | undefined}) => number}
 */
module.exports = function sortDocumentDefinitions(a, b) {
  if (a.kind === 'OperationDefinition') return -1;
  if (b.kind === 'OperationDefinition') return 1;

  // Throw errors if name is missing
  if (!a.name) throw new Error(`sortDocumentDefinitions: 'a' is missing 'name' (kind: ${a.kind})`);
  if (!b.name) throw new Error(`sortDocumentDefinitions: 'b' is missing 'name' (kind: ${b.kind})`);

  // Now we know both a.name and b.name exist, compare their values
  if (a.name.value < b.name.value) return -1;
  if (a.name.value > b.name.value) return 1;
  return 0;
};
